export const HumanReadableTextFormatterLang = {
  kr: 'kr',
  en: 'en',
  jp: 'jp',
} as const;

export abstract class HumanReadableTextFormatterInterface<
  Props extends { lang?: keyof typeof HumanReadableTextFormatterLang },
  Result,
> {
  protected readonly props: Props;

  constructor(props: Props) {
    this.props = props;
  }

  public humanize(): Result {
    const { lang } = this.props;

    switch (lang) {
      case HumanReadableTextFormatterLang.en:
        return this.toEN();
      case HumanReadableTextFormatterLang.jp:
        return this.toJP();
      case HumanReadableTextFormatterLang.kr:
      default:
        return this.toKR();
    }
  }

  protected abstract toKR(): Result;

  protected abstract toEN(): Result;

  protected abstract toJP(): Result;
}
